import * as firebase from "firebase";
import momentService from "../services/momentservice";
import store from "../store";

export default {
  autoUpgradeAnonymousUsers: true,
  // signInSuccessUrl: '/overview',
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.FacebookAuthProvider.PROVIDER_ID
  ],
  // Terms of service url.
  tosUrl: "/tos",
  callbacks: {
    signInSuccessWithAuthResult() {
      store.dispatch("setCookieConsented", true);
      return false;
    },
    signInFailure(error) {
      window.console.log(error);
      // For merge conflicts, the error.code will be
      // 'firebaseui/anonymous-upgrade-merge-conflict'.
      if (error.code !== "firebaseui/anonymous-upgrade-merge-conflict") {
        return Promise.resolve();
      }
      store.dispatch("setCookieConsented", true);
      // Hold a reference to the anonymous current user.
      const anonymousUser = firebase.auth().currentUser;
      // The credential the user tried to sign in with.
      const cred = error.credential;

      // Temp variable to hold the anonymous user data if needed.
      let data = null;
      // If using Firebase Realtime Database. The anonymous user data has to be
      // copied to the non-anonymous user.
      return (
        momentService
          .getMoments(anonymousUser.uid)
          .then(snapshot => {
            data = snapshot;
            const deletes = [];
            for (let i = 0; i < data.length; i += 1) {
              window.console.log(`Deleting moment ${data[i].id}`);
              const moment = data[i];
              deletes.push(momentService.deleteMoment(moment.id).then(() => window.console.log(`Deleted ${moment.id}`)));
            }

            // signInWithCredential will trigger onAuthStateChanged listener which
            // could trigger a redirect to another page.
            // Ensure the upgrade flow is not interrupted by that callback
            // and that this is given enough time to complete before
            // redirection.
            return Promise.all(deletes).then(() => firebase.auth().signInWithCredential(cred));
          })
          .then(() => {
            const transfers = [];
            for (let i = 0; i < data.length; i += 1) {
              window.console.log(`Moving moment ${data[i].id}`);
              const moment = data[i];
              const momentId = moment.id;
              delete moment.id;
              moment.userId = store.state.user.userId;

              transfers.push(momentService.saveMoment(moment)(() => window.console.log(`Saved ${momentId} to ${moment.id}`)));
            }
            return Promise.all(transfers);
          })
          .then(() => window.console.log("Moved all moments and deleted the old ones"))
          // Original Anonymous Auth instance now has the new user.
          .then(() => anonymousUser.delete()) // Delete anonymnous user.
          .then(() => {
            // Clear data in case a new user signs in, and the state change
            // triggers.
            data = null;
            // FirebaseUI will reset and the UI cleared when this promise
            // resolves.
            // signInSuccess will not run. Successful sign-in logic has to be
            // run explicitly.
            // window.location.assign('/');
          })
      );
    }
  }
};
